import { useWhiteLabelStore } from "@/contexts/whiteLabelContext";
import { extendTheme, ThemeConfig } from "@chakra-ui/react";

const createTheme = () => {
  const config: ThemeConfig = {
    initialColorMode: "light",
    useSystemColorMode: false,
  };

  const getAssets = useWhiteLabelStore.getState().getAssets;
  const { primaryColor, secondaryColor } = getAssets();

  const theme = extendTheme({
    config,
    colors: {
      primary: primaryColor,
      secondary: secondaryColor,
      brand: {
        500: "#48bb78",
      },
    },
    fonts: {
      heading: "Lexend Deca, sans-serif",
      body: "Lexend Deca, sans-serif",
    },
    components: {
      Button: {
        baseStyle: {
          fontWeight: "bold",
        },
        variants: {
          solid: (props: { colorScheme: string }) => ({
            bg: props.colorScheme,
            color: "white",
            _hover: {
              bg: props.colorScheme,
              filter: "brightness(90%)",
            },
          }),
          outline: (props: { colorScheme: string }) => ({
            border: "2px solid",
            borderColor: props.colorScheme,
            color: props.colorScheme,
          }),
        },
      },
      Tooltip: {
        baseStyle: {
          bg: "gray.700",
          color: "white",
          fontSize: "sm",
          fontWeight: "medium",
          px: 2,
          py: 1,
          borderRadius: "md",
          maxW: "320px",
          zIndex: 1500,
        },
        defaultProps: {
          placement: "bottom",
          hasArrow: true,
          openDelay: 300,
          closeDelay: 100,
          portalProps: {
            appendToParentPortal: false,
          },
        },
      },
    },
    styles: {
      global: {
        body: {
          overflowX: "hidden",
        },
      },
    },
  });

  return theme;
};

export default createTheme;
